/** @jsxImportSource @emotion/react */
import { Theme, css } from '@emotion/react';

const dividerStyle = (height: undefined | number) => (theme: Theme) => css`
  background-color: ${theme.var.gray100};
  height: ${height ?? 10}px;
  width: 100%;
`;

export interface DividerProps {
  data?: { height?: number };
}

const Divider = ({ data = { height: 8 } }: DividerProps) => {
  const { height } = data;

  return <div css={dividerStyle(height)} />;
};

export default Divider;
